<template>
  <div class="app-container">
    <BjRouteTabs />
    <div class="flex">
      <div class="aside">
        <BjDivider>
          操作
          <template #right><el-button @click="onReset">{{ $t('resetText') }}</el-button></template>
        </BjDivider>
        <el-form label-suffix="：">
          <el-form-item label="单据号">
            <BjInput
              ref="codeDom"
              v-model="form.code"
              placeholder="出库通知单号/物流单号"
              @keyup.enter.native="onChangeCode"
            />
          </el-form-item>
          <el-form-item :label="$t('goodsPage.skuCode')">
            <BjInput
              ref="skuCodeDom"
              v-model="form.skuCode"
              placeholder="系统SKU编码"
              @keyup.enter.native="onChangeSkuCode"
            />
          </el-form-item>

          <el-descriptions
            :column="1"
            border
            style="margin-top: 20px;"
            :label-style="{ width: '120px' }"
            :content-style="{ 'max-width': '208px' }"
            content-class-name="ellipsis"
          >
            <el-descriptions-item label="店铺名称">
              {{ data.shopName }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                出库通知单号
              </template>
              {{ data.code }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                客户订单号
              </template>
              {{ data.platformOrderCode }}
            </el-descriptions-item>
            <el-descriptions-item v-if="data.logisticCompany">
              <template slot="label">
                {{ data.logisticBusiness }}
              </template>
              {{ data.logisticsNo }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                收件信息
              </template>
              {{ data.receiverNameMask }} {{ data.receiverPhoneMask }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                收件地址
              </template>
              {{ data.addressMask }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                买家备注
              </template>
              {{ data.buyMsg }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                客服备注
              </template>
              {{ data.orderMsg }}
            </el-descriptions-item>
          </el-descriptions>
          <el-row class="text-center" style="margin:20px 0;">
            <el-col :span="12" class="checkText">
              <p>应验</p>
              <span>{{ data.qty || 0 }}</span>
            </el-col>
            <el-col :span="12" class="checkText">
              <p>已验</p>
              <span class="success">{{ checkedNum }}</span>
            </el-col>
          </el-row>
          <el-form-item prop="printFlag" label="扫描后打印面单">
            <el-switch v-model="printFlag" />
          </el-form-item>
          <el-form-item prop="print" label="打印机">
            <BjSelectLov
              v-if="webSocketOptions.length"
              v-model="print"
              :option-list="webSocketOptions"
              :clearable="false"
            />
            <template v-else>
              <span>未获取打印机</span>
              <el-button type="text" class="ml15" @click="onConnet">连接打印机</el-button>
            </template>
          </el-form-item>
        </el-form>
      </div>
      <div class="main">
        <el-table :data="data.odoDetailList">
          <el-table-column prop="spuCode" label="商品编码" align="center" />
          <el-table-column prop="spuName" label="商品名称" align="center" width="200" />
          <el-table-column prop="skuCode" label="SKU编码" align="center" />
          <el-table-column prop="skuName" label="SKU名称" align="center" width="200" />
          <el-table-column prop="plannedQty" label="需求数/订单数量" align="center" width="150" />
          <el-table-column prop="checkQty" label="检验数/出库数量" align="center" width="150">
            <template slot-scope="{ row }">
              {{ row.checkQty || 0 }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 弹窗组件 -->
    <Alert ref="alert" />
    <!-- 声音 -->
    <audio ref="alertAudioEl" autoplay :src="audioUrl" />
  </div>
</template>
<script>
import { ORDER_STOCK_OUT_TYPE_LIST } from '@/utils/constants';
import { stockApi } from '@/api';
import Alert from './components/Alert.vue';
import { randomID } from '@/utils';
import webSocket from '@/utils/websocket';
const defaultForm = () => {
  return {
    code: null,
    skuCode: null,
  };
};
const defaultData = () => {
  return {
    buyMsg: null,
    channelTypeCode: null,
    channelTypeCodeMeaning: null,
    code: null,
    creationDate: null,
    frontRecordCode: null,
    frontRecordId: null,
    frontRecordType: null,
    id: null,
    logisticBusiness: null,
    logisticBusinessCode: null,
    logisticBusinessId: null,
    logisticCompany: null,
    logisticCompanyCode: null,
    logisticCompanyId: null,
    logisticsNo: null,
    odoDetailList: [
      // {
      //   alreadyOutQty: 0,
      //   cancelQty: 0,
      //   categoryName: null,
      //   id: null,
      //   odoId: null,
      //   orderGoodsLineIds: [],
      //   plannedQty: 0,
      //   skuCode: null,
      //   skuName: null,
      //   spuCode: null,
      //   spuName: null,
      //   waitOutQty: 0,
      // },
    ],
    odoId: null,
    orderCode: null,
    orderId: null,
    orderMsg: null,
    outLogicWarehouseCode: null,
    outLogicWarehouseId: null,
    outLogicWarehouseName: null,
    outType: null,
    outTypeMeaning: null,
    platformOrderCode: null,
    qty: null,
    receiverAddress: '',
    receiverCity: '',
    receiverCountry: '',
    receiverDistrict: '',
    receiverMobile: '',
    receiverName: '',
    receiverProvince: '',
    resultCodeAndIdList: [
      // {
      //   code: null,
      //   id: 0,
      // },
    ],
    shopCode: null,
    shopId: null,
    shopName: null,
    sorBuyerNikeName: null,
    status: null,
    waybillMessage: null,
    waybillPrintMessage: null,
    waybillPrintStatus: false,
    waybillPrintType: null,
    waybillStatus: null,
    waybillStatusMeaning: null,
    receiverNameMask: null,
    receiverPhoneMask: null,
    addressMask: null,
  };
};

export default {
  name: 'BusinessStockConsignCheck',
  components: { Alert },
  data() {
    return {
      ORDER_STOCK_OUT_TYPE_LIST,
      form: defaultForm(),
      tableData: [],
      data: defaultData(),
      // 成功提示音频
      audioUrl: null,
      audioData: {
        success: require('@/assets/mp3/success.wav'),
        error: require('@/assets/mp3/error.wav'),
      },
      webSocketOptions: [],
      printFlag: null,
      print: null,
    };
  },
  computed: {
    checkedNum() {
      let num = 0;
      this.data.odoDetailList.forEach(item => {
        num += item.checkQty;
      });
      return num;
    },
  },
  watch: {},
  created() {
    this.initPrint();
  },
  mounted() {
    /*
     * 进入页面后，光标自动锁定单据号输入框，
     * 单据号输入框提交成功后，光标自动移入SKU编码输入框
     */
    this.$nextTick(() => {
      this.$refs.codeDom.focus();
    });
  },
  methods: {
    onReset() {
      this.form = defaultForm();
      this.data = defaultData();
      this.$nextTick(() => {
        this.$refs.codeDom.focus();
      });
    },
    onChangeCode() {
      if (this.form.code) {
        stockApi
          .getDeliveryOrderWaybillsDetail({
            queryCode: this.form.code,
          })
          .then(res => {
            if (!res.false) {
              this.$refs.codeDom.focus();
              // 单据号不存在相关操作
              if (!res.id) {
                this.$refs.alert.show('无当前发货单，请重新扫描！');
                this.onReset();
                this.$refs.codeDom.focus();
                return;
              }
              // 单据状态≠待出库或待通知WMS
              if (![0, 1].includes(res.status)) {
                this.$refs.alert.show(
                  `发货单状态：${ORDER_STOCK_OUT_TYPE_LIST.bjGet(
                    res.status,
                  )}，不允许操作，请重新扫描！`,
                );
                this.onReset();
                return;
              }
              // 单据状态=待出库,物流单号为空
              if (!res.logisticsNo) {
                this.$refs.alert.show('发货单物流单号为空，无法操作发货，请重新扫描！');
                this.onReset();
                return;
              }
              // 成功需要一个语音提示
              res.odoDetailList = res.odoDetailList.map(item => {
                return {
                  ...item,
                  checkQty: 0,
                };
              });
              this.data = res;
              this.$refs.skuCodeDom.focus();
            }
          });
      }
    },
    onChangeSkuCode() {
      const v = this.form.skuCode;
      if (v) {
        const LIST = this.data.odoDetailList;
        // 单据号为空
        if (!this.form.code) {
          this.$refs.alert.show('请先扫描或输入有效的单据号');
          this.form.skuCode = null;
          this.audioError();
          return;
        }
        // SKU编码不符合需求明细SKU
        if (LIST.filter(e => e.skuCode === v).length === 0) {
          this.$refs.alert.show('请先扫描或输入有效的SKU编码');
          this.form.skuCode = null;
          this.audioError();
          return;
        }
        // SKU编码数量超出
        const DATA = LIST.find(e => e.skuCode === v);
        if (DATA && DATA.checkQty === DATA.plannedQty) {
          this.$refs.alert.show(`SKU编码【${DATA.skuCode}】已全部检验完成`);
          this.form.skuCode = null;
          this.audioError();
          return;
        }
        if (LIST.filter(e => e.skuCode === v).length) {
          const index = LIST.findIndex(e => e.skuCode === v);
          LIST[index].checkQty++;
          this.form.skuCode = null;
          this.audioSuccess();
        }
        // 需求数=检验数，
        // 执行出库操作，生成出库结果单
        // 出库状态变更：全部出库，触发对应平台发货状态回传
        if (this.data.qty === this.checkedNum) {
          const ids = [this.data.odoId];
          stockApi.batchSendStockToOutboundDeliveryOrderWaybills({ ids }).then(res => {
            if (res.failQty) {
              this.$refs.alert.show('检验出库失败');
            } else {
              this.$refs.alert.show('检验出库成功');
              this.onReset();
            }
          });
          // 开启打印
          if (this.printFlag) {
            // 定义打印数据
            stockApi
              .printToOutboundDeliveryOrderWaybills({
                printList: [this.data.odoId],
              })
              .then(res => {
                if (res.printDatas.length) {
                  const print = {
                    task: {
                      documents: res.printDatas.map(item => {
                        return {
                          contents: JSON.parse(item.data),
                          documentID: item.id,
                        };
                      }),
                      printer: this.print, // 打印机名称
                      taskID: randomID(),
                    },
                  };
                  // 打印机打印
                  webSocket.print(print);
                }
              });
          }
        }
      }
    },
    audioSuccess() {
      this.audioUrl = this.audioData['success'];
      this.$refs.alertAudioEl.play();
    },
    audioError() {
      this.audioUrl = this.audioData['error'];
      this.$refs.alertAudioEl.play();
    },
    onConnet() {
      this.initPrint();
    },
    initPrint() {
      webSocket.init(res => {
        if (res.cmd === 'getPrinters') {
          const { defaultPrinter, printers } = webSocket.printerData;
          this.webSocketOptions = printers;
          this.print = defaultPrinter;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.aside {
  width: 350px;
  border-right: 1px solid #dcdfe6;
  padding-right: 20px;
}
.main {
  width: calc(100% - 370px);
  margin-left: 20px;
}
.checkText p,
.checkText span {
  margin: 0;
  font-weight: bold;
  font-size: 48px;
}
.success {
  color: $green;
}
</style>
